<script>
import { actions, getters } from '../utils'
import Sidebar from 'views/components/navigation/Sidebar'

export default {
  components: { Sidebar },
  data() {
    return {
      isOpenOnDesktop: true,
    }
  },
  computed: {
    isOpen() {
      return this.isOpenOnDesktop && this.screenSizes.includes('sm')
    },
    ...getters('localStorage', 'screenSizes'),
  },
  methods: actions('SET_LOCAL_STORAGE'),
  watch: {
    isOpenOnDesktop(isSidebarOpen) {
      if (this.screenSizes.includes('sm')) {
        this.SET_LOCAL_STORAGE({ isSidebarOpen })
      }
    },
    screenSizes: {
      handler(sizes) {
        this.isSidebarOpen = sizes.includes('sm')
          ? !!this.localStorage('isSidebarOpen')
          : false
      },
    },
  },
}
</script>
